/**
 * @generated SignedSource<<a82785a5bc78e6cfdee173771487b986>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cityId",
        "variableName": "cityId"
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      }
    ],
    "concreteType": "CityResponseType",
    "kind": "LinkedField",
    "name": "getDestinationsBySource",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "CMCityname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "CMCityid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PickupDropLocations",
        "kind": "LinkedField",
        "name": "pickupDropPoints",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetDestinationListingQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetDestinationListingQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6564ab05b9c14e93a43eda08bc90bc83",
    "id": null,
    "metadata": {},
    "name": "GetDestinationListingQuery",
    "operationKind": "query",
    "text": "query GetDestinationListingQuery(\n  $cityId: Int!\n  $searchTerm: String\n) {\n  getDestinationsBySource(cityId: $cityId, searchTerm: $searchTerm) {\n    CMCityname\n    CMCityid\n    pickupDropPoints {\n      cityId\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "965fbd0a1ad7773868798dd6c1b85fbd";

module.exports = node;
